import { Modelo } from '@ext/index';
import * as Types from './Chat.types';
import moment, { Moment } from 'moment';
import { Cliente } from '@/__env/lib/Clientes';
import { Mensaje } from '@/__env/lib/MercadoLibre/Chats/Mensajes';

export class IChat extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Pack: number = 0;
    public Cuenta: string = '';
    public CuentaId: number = 0;
    public Estado: string = '';
    public UltimoMensaje: Mensaje = new Mensaje();
    public PrimerMensaje: string = '';
    public Cliente: Cliente = new Cliente();
    public ClienteId: number = 0;
    public Envio: number = 0;
    public Reclamo: number = 0;



    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;
        json.pack = this.Pack;
        json.cuenta = this.Cuenta;
        json.cuenta_id = this.CuentaId;
        json.estado = this.Estado;
        json.ultimo_mensaje = this.UltimoMensaje;
        //json.cliente = this.Cliente.Id;
        json.cliente_id = this.ClienteId;
        json.envio = this.Envio;
        json.reclamo = this.Reclamo;


        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Pack = !this.Json.pack ? 0 : this.Json.pack;
        this.Cuenta = !this.Json.cuenta ? '' : this.Json.cuenta;
        this.CuentaId = !this.Json.cuenta_id ? 0 : this.Json.cuenta_id;
        this.Estado = !this.Json.estado ? '' : this.Json.estado;

        this.ClienteId = !this.Json.cliente_id ? 0 : this.Json.cliente_id;
        this.Envio = !this.Json.envio ? 0 : this.Json.envio;
        this.Reclamo = !this.Json.reclamo ? 0 : this.Json.reclamo;

        if ( this.Json.cliente )
            this.Cliente = new Cliente( this.Json.cliente );

        if ( this.Json.ultimo_mensaje )
            this.UltimoMensaje = new Mensaje( this.Json.ultimo_mensaje );

        this.PrimerMensaje = this.Json.primer_mensaje;

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IChat )
    {
        this.Model = Model;
    }

    public Model: IChat;
}